/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IWebgroupSearchControlsViewProps } from './webgroup-search-controls';

export default (props: IWebgroupSearchControlsViewProps) => {
    const { webgroupFilters, webgroupCategories, categoryId } = props;
    return (
        <div className='webgroup-search-controls'>
            {categoryId ? <div>{webgroupFilters}</div> : null}
            <div>{webgroupCategories}</div>
        </div>
    );
};
